/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 留资
 */
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';
export class IsgBaseInfoController<T = any> extends BasesController<T> {
  dcscToken = '';
  dcscAuthority = false;
  configTool = false;
  dcscUrl = '';

  /** isg是否绑定微信 */
  isgIsBindWechat() {
    return AjaxBasics.request(EnumAPI.accountsvr_isg_isbind_wechat);
  }

  /** dcsc单点登录获取token */
  async getDcscToken() {
    this.dcscToken = await AjaxBasics.request(EnumAPI.accountsvr_dcsc_login);
    console.log('zhaoyu ~ this.dcscToken', this.dcscToken);
  }

  /** 获取dcsc菜单权限 */
  async getDcscAuthority() {
    this.dcscAuthority = await AjaxBasics.request(
      EnumAPI.accountsvr_dcsc_get_authority,
    );
    console.log('zhaoyu ~ this.dcscAuthority', this.dcscAuthority);
  }

  /** 获取dcsc菜单信息 */
  // async getDcscInfo() {
  //   try {
  //     await this.getDcscAuthority();
  //     if (this.dcscAuthority) {
  //       await this.getDcscToken();
  //     }
  //   } catch (error) {}
  // }

  /** 获取配置工具权限 */
  async getConfigTool() {
    this.configTool = await AjaxBasics.request(
      EnumAPI.content_configTool_userGroup,
    );
  }

  /** 获取dcsc菜单地址 */
  async getDcscUrl() {
    this.dcscUrl = await AjaxBasics.request(
      EnumAPI.accountsvr_dcsc_get_redirectUrl,
    );
    console.log('zhaoyu ~ this.dcscUrl', this.dcscUrl);
  }
}
